<app-content-header backLabel="app_back" [historyBack]="false" (backEvent)="onBack()" [headline]="'phonenumber_cancel_headline' | i18next"></app-content-header>

<div class="row d-flex justify-content-center mt-2">
  <div class="col-sm-12 col-lg-8 col-xl-6 mb-3 mb-lg-0">
    <div class="card card-nb">
      <div class="d-flex card-header header-red card-nb shadow-sm">
        <div class="h3 mx-auto">{{ 'phonenumber_cancel_headline' | i18next }}</div>
      </div>
      <div class="card-body pb-0 pt-0">
        <div class="p-3 d-flex flex-column h-100">
          <div class="h3 red" >{{ 'summary_headline' | i18next }}</div>

          <div class="mt-3">
            <i class="fa fa-info-circle red mr-2"></i>
            <span class="subinformations mb-3" [innerHTML]="block.locationIndependent ? ('cancel_location_independent_number_info_text' | i18next) : 
              'cancel_location_dependent_number_info_text' | i18next: { cancellationDate: cancellationDate | localized_date }"></span>
          </div>

          <div class="subinformations mb-3" [innerHTML]="blockText"></div>

          <app-pascom-checkbox class="mt-5"
            [text]="block.locationIndependent ? ('cancel_location_independent_number_checkbox_text' | i18next) : 
              'cancel_location_dependent_number_checkbox_text' | i18next: { cancellationDate: cancellationDate | localized_date }"
              (acceptChanged)="doCheck($event)">
          </app-pascom-checkbox>

          <div class="d-flex justify-content-end mt-2">
            <button [disabled]="!checked" class="btn btn-outline-primary" (click)="onConfirm()">
              {{ 'app_next' | i18next }}
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>